import styled from 'styled-components';
import { motion } from 'framer-motion';

export const ChatWindowWrapper = styled.div`
  background: white;
  border-radius: 16px;
  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);
  border: 1px solid #e5e7eb;
  overflow: hidden;
  backdrop-filter: blur(10px);
  background: rgba(255, 255, 255, 0.95);
  
  @media (max-width: 768px) {
    border-radius: 12px;
    box-shadow: 0 15px 20px -5px rgba(0, 0, 0, 0.1), 0 8px 8px -5px rgba(0, 0, 0, 0.04);
  }
  
  @media (max-width: 480px) {
    border-radius: 10px;
    box-shadow: 0 10px 15px -5px rgba(0, 0, 0, 0.1), 0 5px 5px -5px rgba(0, 0, 0, 0.04);
  }
  
  @media (max-width: 360px) {
    border-radius: 8px;
    box-shadow: 0 8px 12px -5px rgba(0, 0, 0, 0.1), 0 4px 4px -5px rgba(0, 0, 0, 0.04);
  }
`;

export const Header = styled.div`
  background: linear-gradient(135deg, #3b82f6 0%, #8b5cf6 100%);
  padding: 16px;
  color: white;
  
  @media (max-width: 768px) {
    padding: 12px;
  }
  
  @media (max-width: 480px) {
    padding: 10px;
  }
  
  @media (max-width: 360px) {
    padding: 8px;
  }
`;

export const HeaderContent = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  
  @media (max-width: 480px) {
    flex-direction: column;
    gap: 8px;
    align-items: flex-start;
  }
`;

export const HeaderLeft = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  
  @media (max-width: 480px) {
    gap: 8px;
  }
`;

export const HeaderTitle = styled.h3`
  font-weight: 600;
  font-size: 18px;
  margin: 0;
  
  @media (max-width: 768px) {
    font-size: 16px;
  }
  
  @media (max-width: 480px) {
    font-size: 14px;
  }
  
  @media (max-width: 360px) {
    font-size: 13px;
  }
`;

export const HeaderSubtitle = styled.p`
  font-size: 12px;
  opacity: 0.9;
  margin: 0;
  
  @media (max-width: 768px) {
    font-size: 11px;
  }
  
  @media (max-width: 480px) {
    font-size: 10px;
  }
  
  @media (max-width: 360px) {
    font-size: 9px;
  }
`;

export const HeaderRight = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  
  @media (max-width: 480px) {
    gap: 6px;
  }
`;

export const IconButton = styled.button`
  padding: 4px;
  background: rgba(255, 255, 255, 0.2);
  border: none;
  border-radius: 8px;
  color: white;
  cursor: pointer;
  transition: background-color 0.2s ease;
  
  @media (max-width: 480px) {
    padding: 3px;
    border-radius: 6px;
  }
  
  @media (max-width: 360px) {
    padding: 2px;
    border-radius: 4px;
  }

  &:hover {
    background: rgba(255, 255, 255, 0.3);
  }
`;

export const MessagesContainer = styled.div`
  height: 384px;
  overflow-y: auto;
  padding: 16px;
  background: #f9fafb;
  background: rgba(249, 250, 251, 0.5);
  display: flex;
  flex-direction: column;
  gap: 16px;
  
  @media (max-width: 768px) {
    height: 320px;
    padding: 12px;
    gap: 12px;
  }
  
  @media (max-width: 480px) {
    height: 280px;
    padding: 10px;
    gap: 10px;
  }
  
  @media (max-width: 360px) {
    height: 240px;
    padding: 8px;
    gap: 8px;
  }
`;

export const WelcomeMessage = styled.div`
  text-align: center;
  padding: 32px 0;
  
  @media (max-width: 768px) {
    padding: 24px 0;
  }
  
  @media (max-width: 480px) {
    padding: 20px 0;
  }
  
  @media (max-width: 360px) {
    padding: 16px 0;
  }
`;

export const WelcomeIcon = styled.div`
  width: 48px;
  height: 48px;
  background: linear-gradient(135deg, #3b82f6 0%, #8b5cf6 100%);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 16px;
  
  @media (max-width: 768px) {
    width: 40px;
    height: 40px;
    margin: 0 auto 12px;
  }
  
  @media (max-width: 480px) {
    width: 36px;
    height: 36px;
    margin: 0 auto 10px;
  }
  
  @media (max-width: 360px) {
    width: 32px;
    height: 32px;
    margin: 0 auto 8px;
  }
`;

export const WelcomeTitle = styled.h4`
  font-weight: 600;
  color: #1f2937;
  margin: 0 0 8px 0;
  
  @media (max-width: 768px) {
    font-size: 16px;
    margin: 0 0 6px 0;
  }
  
  @media (max-width: 480px) {
    font-size: 14px;
    margin: 0 0 4px 0;
  }
  
  @media (max-width: 360px) {
    font-size: 13px;
    margin: 0 0 4px 0;
  }
`;

export const WelcomeText = styled.p`
  color: #6b7280;
  margin: 0 0 24px 0;
  
  @media (max-width: 768px) {
    font-size: 13px;
    margin: 0 0 20px 0;
  }
  
  @media (max-width: 480px) {
    font-size: 12px;
    margin: 0 0 16px 0;
  }
  
  @media (max-width: 360px) {
    font-size: 11px;
    margin: 0 0 12px 0;
  }
`;

export const QuickQuestionsGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 8px;
  max-width: 384px;
  margin: 0 auto;
  
  @media (max-width: 768px) {
    gap: 6px;
    max-width: 320px;
  }
  
  @media (max-width: 480px) {
    gap: 4px;
    max-width: 280px;
  }
  
  @media (max-width: 360px) {
    gap: 3px;
    max-width: 240px;
  }
`;

export const QuickQuestionButton = styled(motion.button)`
  text-align: left;
  padding: 12px;
  background: white;
  border-radius: 8px;
  border: 1px solid #e5e7eb;
  cursor: pointer;
  transition: all 0.2s ease;
  font-size: 14px;
  
  @media (max-width: 768px) {
    padding: 10px;
    font-size: 13px;
  }
  
  @media (max-width: 480px) {
    padding: 8px;
    font-size: 12px;
  }
  
  @media (max-width: 360px) {
    padding: 6px;
    font-size: 11px;
  }

  &:hover {
    border-color: #3b82f6;
    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);
  }
`;

export const InputArea = styled.div`
  border-top: 1px solid #e5e7eb;
  padding: 16px;
  background: white;
  background: rgba(255, 255, 255, 0.9);
  
  @media (max-width: 768px) {
    padding: 12px;
  }
  
  @media (max-width: 480px) {
    padding: 10px;
  }
  
  @media (max-width: 360px) {
    padding: 8px;
  }
`;

export const Form = styled.form`
  display: flex;
  align-items: flex-end;
  gap: 8px;
  
  @media (max-width: 480px) {
    flex-direction: column;
    align-items: stretch;
    gap: 6px;
  }
`;

export const TextInput = styled.textarea`
  flex: 1;
  padding: 8px 16px;
  border: 1px solid #d1d5db;
  border-radius: 8px;
  font-size: 14px;
  font-family: inherit;
  resize: none;
  min-height: 40px;
  max-height: 120px;
  
  @media (max-width: 768px) {
    padding: 6px 12px;
    font-size: 13px;
    min-height: 36px;
    max-height: 100px;
  }
  
  @media (max-width: 480px) {
    padding: 5px 10px;
    font-size: 12px;
    min-height: 32px;
    max-height: 80px;
  }
  
  @media (max-width: 360px) {
    padding: 4px 8px;
    font-size: 11px;
    min-height: 28px;
    max-height: 70px;
  }

  &:focus {
    outline: none;
    border-color: #3b82f6;
    box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
  }
`;

export const SendButton = styled.button`
  padding: 8px;
  background: linear-gradient(135deg, #3b82f6 0%, #8b5cf6 100%);
  color: white;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  
  @media (max-width: 768px) {
    padding: 6px;
    border-radius: 6px;
  }
  
  @media (max-width: 480px) {
    padding: 5px;
    border-radius: 6px;
  }
  
  @media (max-width: 360px) {
    padding: 4px;
    border-radius: 4px;
  }

  &:hover {
    background: linear-gradient(135deg, #2563eb 0%, #7c3aed 100%);
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

export const CharacterCount = styled.div`
  font-size: 12px;
  color: #6b7280;
  text-align: right;
  margin-top: 4px;
  
  @media (max-width: 768px) {
    font-size: 11px;
  }
  
  @media (max-width: 480px) {
    font-size: 10px;
  }
  
  @media (max-width: 360px) {
    font-size: 9px;
  }
`;

export const TokenInfo = styled.div`
  position: relative;
`;

export const TokenInfoPopup = styled(motion.div)`
  position: absolute;
  right: 0;
  top: 32px;
  background: #1f2937;
  color: white;
  padding: 8px;
  border-radius: 6px;
  font-size: 12px;
  width: 192px;
  z-index: 10;
  
  @media (max-width: 768px) {
    width: 160px;
    font-size: 11px;
    padding: 6px;
  }
  
  @media (max-width: 480px) {
    width: 140px;
    font-size: 10px;
    padding: 5px;
  }
  
  @media (max-width: 360px) {
    width: 120px;
    font-size: 9px;
    padding: 4px;
  }
`;

export const TokenInfoRow = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 4px;
`;

export const TokenProgressBar = styled.div`
  margin-top: 8px;
  background: #374151;
  border-radius: 4px;
  height: 8px;
  overflow: hidden;
`;

export const TokenProgressFill = styled.div`
  height: 100%;
  transition: width 0.3s ease;
`;
